import apiFetch from '../apiFetch'

export default function (token, processingAgencyId) {
  return apiFetch({ endPoint: 'ProcessingAgency/' + processingAgencyId, method: 'GET', token: token })
}
